
import Radio from 'vux/src/components/radio/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Popup from 'vux/src/components/popup/index.vue'

import axios from 'axios'
export default {
components: {
Group,
Cell,
ViewBox,
XHeader,
XButton,
Box,
XInput,
PopupRadio,
Popup,
Radio
},
beforeCreate: function () {
document.body.className = 'charge'
},
data () {
return {
bdorderNum: '',
bdamount: '',
bdactname: '',
bdactnum: '',
bdbankimgsrc: '',
bdqrimgsrc: '',
bdbankname: '',
qrimage: false,
bankimg: true
}
},
mounted () {
var self = this
self.getorderno()
},
methods: {
copyText (idtext) {
let textToCopy = document.getElementById(idtext)
let self = this
var range
if (document.body.createTextRange) {
range = document.body.createTextRange()
range.moveToElementText(textToCopy)
range.select()
document.execCommand('Copy')
self.$vux.toast.show({
'text': 'Sao chép！',
'type': 'success'
})
} else if (window.getSelection) {

var selection = window.getSelection()
range = document.createRange()
range.selectNodeContents(textToCopy)
selection.removeAllRanges()
selection.addRange(range)
document.execCommand('Copy')
self.$vux.toast.show({
'text': 'Sao chép！',
'type': 'success'
})
}
},
getorderno () {
const queryString = window.location.search
const urlParams = new URLSearchParams(queryString)
const getparams = urlParams.get('order_no')
var bdbankdetails = {
115: {name: 'Techcombank', sign: 'TCB'},
116: {name: 'Sacombank', sign: 'SAC'},
117: {name: 'Vietcombank', sign: 'VCB'},
118: {name: 'Asia Commercial Bank', sign: 'ACB'},
119: {name: 'DongA Bank', sign: 'DAB'},
120: {name: 'Vietin Bank', sign: 'VTB'},
121: {name: 'Bank for Investment and Development of Vietnam', sign: 'BIDV'},
122: {name: 'Eximbank Vietnam', sign: 'EXB'},
123: {name: 'Bank Central Asia', sign: 'BCA'},
124: {name: 'Bank Negara Indonesia', sign: 'BNI'},
125: {name: 'Bank Rakyat Indonesia', sign: 'BRI'},
126: {name: 'Mandiri Bank', sign: 'MDR'},
127: {name: 'CIMB Niaga', sign: 'CIMBN'},
128: {name: 'Vietnam Prosperity Joint-Stock Commercial Bank', sign: 'VP'},
129: {name: 'Military Commercial Joint Stock Bank', sign: 'MB'},
130: {name: 'Tien Phong Commercial', sign: 'TPB'},
131: {name: 'AGRI BANK', sign: 'AGRI'},
132: {name: 'Lien Viet Post Joint Stock Commercial Bank', sign: 'LienVietPostBank'},
133: {name: 'Saigon – Hanoi Commercial Joint Stock Bank', sign: 'SHB'},
134: {name: 'Vietnam Public Joint-stock Commercial Bank', sign: 'PVcombank'},
1000: {name: 'Others Bank', sign: 'OTHERS'}
}
console.log(getparams)
let self = this
if (getparams !== null) {
axios({
url: 'https://payvndnow.com/api/deposit/pay?order_no=' + getparams,
headers: {
'Content-type': 'application/x-www-form-urlencoded'
},
method: 'post'
})
.then(function (response) {





if (response.data.success === 1) {
var bankid = response.data.data.bank_id
self.bdorderNum = response.data.data.order_no
self.bdamount = response.data.data.amount
self.bdactname = response.data.data.account_name
self.bdactnum = response.data.data.account_no
self.bdbankimgsrc = 'static/images/vnbanks/' + bdbankdetails[bankid]['sign'] + '.png'
self.bdqrimgsrc = response.data.data.QR_code
self.bdbankname = bdbankdetails[bankid]['name']
if (self.bdqrimgsrc === '') {
self.qrimage = false
} else {
self.qrimage = true
}
if (bdbankdetails[bankid]['sign'] === '' || bdbankdetails[bankid]['sign'] === 'OTHERS') {
self.bankimg = false
} else {
self.bankimg = true
}
console.log(response.data.data.order_no)
} else {
self.$vux.toast.show({
'text': 'kiểm tra số đơn đặt hàng của bạn',
'type': 'warn'
})
self.bankimg = false
self.qrimage = false
self.bdorderNum = '---'
self.bdamount = '---'
self.bdactname = '---'
self.bdactnum = '---'
self.bdbankimgsrc = ''
self.bdqrimgsrc = ''
self.bdbankname = '---'
}
})
.catch(function (error) {
console.log(error)
})
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/BankDetails.vue